module.exports = __webpack_public_path__ + "static/googleplay-48328a9923dec7271752096108420902.png";